export default __webpack_public_path__ + "static/persian_attraction-d48e565f29be8850dab04852a23526b0.png";